import { gql } from '@apollo/client'

/**
 * Home da visão do produtor. O aluno lista produtos pelas matrículas
 * (getUserEnrollments); o colaborador não tem nenhuma, então a lista vem do
 * escopo do painel. Os campos espelham o que o ProductCard consome.
 */
export const GET_ADMIN_PREVIEW_PRODUCTS = gql`
  query getAdminPreviewProducts($offset: Int!, $limit: Int!) {
    adminPreviewProductsCount
    adminPreviewProducts(
      pagination: { limit: $limit, offset: $offset }
      ordenation: { by: "id", direction: "desc" }
    ) {
      id
      title
      logo
      logoVertical
      path {
        id
      }
      courses {
        id
        kind
        lessons(pagination: { offset: 0, limit: 1 }) {
          nodes {
            id
            title
            courseContentId
            media {
              id
              type
              originUrl
              providerKey
              fileExt
              hostKey
              host
              organizationUuid
            }
          }
        }
      }
    }
  }
`
